import useTranslation from 'next-translate/useTranslation'

const PositionHealthBarReview = function ({ health = 'no-position', percent }) {
  const { t } = useTranslation()

  return (
    <>
      <div className="mb-3 flex w-full items-center justify-end text-2xl leading-7 text-white">
        {typeof percent !== 'undefined' && (
          <>
            <span
              className={`${
                health === 'safe'
                  ? 'bg-state-bg-success text-state-success'
                  : ''
              }
              ${
                health === 'risky'
                  ? 'bg-state-bg-warning text-state-warning'
                  : ''
              }
              ${
                health === 'liquidation'
                  ? 'bg-state-bg-error text-state-error'
                  : ''
              }
              ${health === 'no-position' ? 'bg-gray-600/10 text-gray-600' : ''}
              inline-block rounded-lg px-2 py-1 text-base font-medium leading-[22px]`}
            >
              {t(`position.${health}`)}
            </span>
          </>
        )}
      </div>
      <div className="h-2 w-full rounded-full bg-white">
        <div
          className={`${health === 'safe' ? 'bg-state-success' : ''}
            ${health === 'risky' ? 'bg-state-warning' : ''}
            ${health === 'liquidation' ? 'bg-state-error' : ''}
            h-2 rounded-full transition-[width] duration-700`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </>
  )
}

export default PositionHealthBarReview
